import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'antd/dist/antd.min.css';
import './styles/styles.scss';

const container = document.getElementById('root');
if (!container) {
	throw new Error('Root container not found');
}

const root = ReactDOM.createRoot(container);
root.render(<App />);

serviceWorkerRegistration.register();
reportWebVitals();
